import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import NewChart from '../NewChart';

const SilverChart = () => {

    const [title ,setTitle] = useState('silver_chart')
    const [defaultVal ,setDefaultVal] = useState('Silver')
    useEffect(() => {
        if(window.location.hostname.includes("silverprice.org")) {
            setTitle("gold_chart")
            setDefaultVal("Gold")
        }
    }, [])


    return (
            <div class="col-12">
            <div class="small-chart-box well well-sm">
            <div class="performance-table text-center">
            <NewChart title={title} defaultValue = {defaultVal} />
            </div>
            </div>
            </div>
            
    )
       
}

export default SilverChart;
